import React, { useState, useEffect } from "react";
import TextInput from "../../fields/TextInput";
import google from "../../../assets/assets/images/social_icons/google.png";
import facebook from "../../../assets/assets/images/social_icons/facebook.png";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
import {
  Login,
  Logout,
  cleanLogin,
  cleanUp,
  cleanupLoginNotif,
  getUserDetail,
  storeSocialData,
  storeLoginId,
} from "../../../redux/Slice/authSlice";
import { ClipLoader } from "react-spinners";
import axios from "axios";
// import { useGoogleLogin } from '@react-oauth/google';
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { getAllCars } from "../../../redux/Slice/carSlice";
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Index = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { loginId } = useSelector((state) => state?.auth);
  const loginUserDetail = useSelector((state) => state?.auth?.loginDetail);
  const signUserDetail = useSelector((state) => state?.auth?.signupDetail);
  const loginStatus = useSelector((state) => state?.auth?.loginStatus);
  const userInfo = useSelector((state) => state?.auth?.userDetail);
  const navigate = useNavigate();
  const [withPhone, setWithPhone] = useState(false);
  const [errmsg, setErrMsg] = useState({
    email: "",
    phoneErrMsg: "",
    password: "",
  });
  const [loginDetail, setLoginDetail] = useState({ email: "", password: "" });
  const [phone, setPhone] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countyCode, setCountyCode] = useState(null);
  const [user, setUser] = useState(null);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [pwdHide, setPwdHide] = useState(false);
  console.log(errmsg);
  const Googlelogin = useGoogleLogin({
    client_id: googleClientId,
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`
        )
        .then((res) => {
          axios
            .post(`${baseURL}/signupuser/socialLogin`, res.data)
            .then((response) => {
              if (response.data.success === true) {
                // const logintoken = response.data.token;
                // var expirationDate = new Date();
                // expirationDate.setTime(expirationDate.getTime() + (1  60  60 * 1000));
                // expirationDate.setTime(expirationDate.getTime() + (1 * 60 * 60 * 1000));
                // Cookies.set('loginToken', logintoken, { expires: expirationDate });
                dispatch(storeSocialData(response.data));
                // dispatch(getAllCars());
                // navigate("/");
                if (location?.state?.redirectBack)
                  navigate(location?.state?.redirectBack, { replace: true });
                else navigate("/");
              } else {
                toast(response.data.message);
              }
            })
            .catch((error) => {
              console.error("Error sending data to checkGoogleLogin:", error);
            });
        })
        .catch((err) =>
          console.log("Error fetching user info from Google:", err)
        );
    }
  }, [user, navigate]);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setLoginDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
    setErrMsg((prev) => ({ ...prev, [name]: "" }));
  };

  // const handleChange = (newPhone) => {
  //   setPhone(newPhone);
  const handleChange = (newPhone, info) => {
    setCountyCode(info?.countryCallingCode);
    setPhoneNumber(info?.nationalNumber);
    setPhone(newPhone);
  
    setErrMsg((prev) => ({ ...prev, phoneErrMsg: "" }));
  };
  const notify = () => toast(`Login successfully`);

  function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  const toggleLogin = () => {
    setWithPhone(!withPhone);
  };

  // useEffect(() => {

  //     if(userInfo?.data?.userVerified === false) {
  //         navigate('/otp/signup')

  //     }

  // }, [userInfo?.data?.userVerified, loginUserDetail])

  useEffect(() => {
    if (loginUserDetail?.success === true) {
      dispatch(getUserDetail(loginUserDetail?.data?._id));
      dispatch(storeLoginId(loginUserDetail?.data?._id));
      dispatch(getAllCars());
      if (location?.state?.redirectBack)
        navigate(location?.state?.redirectBack, { replace: true });
      else navigate("/");
      if (loginStatus === "fulfilled") {
        notify();
      }
    }
  }, [loginUserDetail]);

  useEffect(() => {
    if (loginId) {
      dispatch(getAllCars());
    }
  }, [loginId]);

  useEffect(() => {
    return () => {
      dispatch(cleanLogin());
      dispatch(cleanupLoginNotif());
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isPhoneValid = matchIsValidTel(phone);
    const mailValid = isValidEmail(loginDetail?.email);
    let newErrMsg = {};

    if (withPhone) {
      if (loginDetail?.password.length < 6)
        newErrMsg = {
          ...newErrMsg,
          password: "Password must be at least 6 characters long",
        };
      if (!isPhoneValid)
        newErrMsg = { ...newErrMsg, phoneErrMsg: "Please Enter valid Phone" };
      setErrMsg(newErrMsg);

      if (loginDetail?.password.length < 6 || !isPhoneValid) {
        return;
      } else {
        dispatch(
          // Login({
          //   type: "phone",
          //   phoneNumber: phone,
          //   password: loginDetail?.password,
          // })
          Login({
            type: "phone",
            phoneNumber: phoneNumber,
            country_code:"+"+countyCode,
            password: loginDetail?.password,
          })
        );

        // if (userInfo?.data?.userVerified === true) {
        //     dispatch(Login({
        //         "type": "phone",
        //         "phoneNumber": phone,
        //         "password": loginDetail?.password
        //     }))
        // } else {
        //     dispatch(cleanUp())
        //     navigate("/signup")
        // }
      }
    } else {
      if (loginDetail?.password.length < 6)
        newErrMsg = {
          ...newErrMsg,
          password: "Password must be at least 6 characters long",
        };
      if (mailValid === false)
        newErrMsg = { ...newErrMsg, email: "Please Enter valid Mail" };
      setErrMsg(newErrMsg);

      if (loginDetail?.password.length < 6 || mailValid === false) {
        return;
      } else {
        dispatch(
          Login({
            type: "email",
            password: loginDetail?.password,
            emailId: loginDetail?.email,
          })
        );

        // if (userInfo?.data?.userVerified === true) {
        //     dispatch(Login({
        //         "type": "email",
        //         "password": loginDetail?.password,
        //         "emailId": loginDetail?.email
        //     }))
        // } else {
        //     dispatch(cleanUp())
        //     navigate("/signup")
        // }
      }
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid px-0">
      <div className="slider_img ">
        <div className="row mx-0 z_999">
          <div className="col-lg-4 px-0">
            <div className="login-div mx-1">
              <h2 className="font accentColor">Log in</h2>
              <div className="mt-1 text-start">
                <p className="secondaryColor fs14">
                  Don't have an account?{" "}
                  <span>
                    <Link to="/signup" className="accentColor">
                      Signup
                    </Link>
                  </span>
                </p>
              </div>
              <div className="mt-2">
                {!withPhone ? (
                  <div className="mb-2">
                    <p className="accentColor fs14 mb-1">
                      Email<span className="text-danger">*</span>
                    </p>
                    <TextInput
                      type="email"
                      // id="email"
                      size="small"
                      name="email"
                      value={loginDetail.email}
                      onChange={handleInput}
                      error={!!errmsg.email}
                      helperText={errmsg.email}
                      formPlaceholder="Enter Your Email"
                      shrink="false"
                      animation="true"
                      requiredStar={true}
                    />
                  </div>
                ) : (
                  <div className="mb-2">
                    <p className="accentColor fs14 mb-1">
                      Phone Number<span className="text-danger">*</span>
                    </p>
                    <MuiTelInput
                      // disableFormatting
                      error={!!errmsg.phoneErrMsg}
                      defaultCountry="ZM"
                      value={phone}
                      onChange={handleChange}
                      variant="outlined"
                      size="small"
                      sx={{ width: "100%" }}
                      helperText={errmsg.phoneErrMsg}
                    />
                  </div>
                )}
                <div className="mb-2">
                  <p className="accentColor fs14 mb-1">
                    Password<span className="text-danger">*</span>
                  </p>
                  <div className="position-relative">
                    <TextInput
                      type={pwdHide ? "text" : "password"}
                      // id="password"
                      size="small"
                      name="password"
                      value={loginDetail.password}
                      onChange={handleInput}
                      error={!!errmsg.password}
                      helperText={errmsg.password}
                      formPlaceholder="Enter Password"
                      shrink="false"
                      animation="true"
                      requiredStar={true}
                    />
                    <span className="position-absolute eye">
                      {pwdHide ? (
                        <FaRegEye onClick={() => setPwdHide(!pwdHide)} />
                      ) : (
                        <FaRegEyeSlash onClick={() => setPwdHide(!pwdHide)} />
                      )}
                    </span>
                  </div>
                </div>
                {loginUserDetail?.success === false ? (
                  <p className="location-err">{loginUserDetail?.message}</p>
                ) : null}
                <div className="flex justify-content-between gap-4">
                  <Link to="/forgetpassword">
                    <p className="secondaryColor fs14 forget-pw mb-3 mt-3">
                      Forget Password?
                    </p>
                  </Link>
                  <p
                    className="secondaryColor fs14 forget-pw mb-3 mt-3 pointor "
                    onClick={toggleLogin}
                  >
                    {withPhone ? "Login with Email" : "Login with Phone"}
                  </p>
                </div>
                <button
                  type="submit"
                  onClick={(e) => {
                    scrollToTop();
                    handleSubmit(e);
                  }}
                  className="btn grid-class w-100 img-btn primaryColor"
                >
                  {loginStatus === "pending" ? null : "Log in"}{" "}
                  <ClipLoader
                    loading={loginStatus === "pending" ? true : false}
                    cssOverride={{ width: "25px", height: "25px" }}
                    color="#fff"
                  />
                </button>
                <h5 className="text-center my-2">Or</h5>
                <div className="d-flex flex-column  gap-3">
                  <button
                    type="button"
                    className="login-with-google-btn"
                    onClick={() => Googlelogin()}
                  >
                    <img src={google} className="google-icon" />
                    Sign in with Google
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
